import { FormBase } from "core/components";
export default class DressingRuleEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "procedureCodeId",
                    label: "Procedure",
                    placeholder: "Select a procedure",
                    rules: "required",
                },
                {
                    name: "hcpcsShortDescription",
                    label: "HCPCS Short Description",
                    placeholder: "Enter HCPCS Short Description",
                    rules: "required|string",
                },
                {
                    name: "hcpcsLongDescription",
                    label: "HCPCS Long Description",
                    placeholder: "Enter HCPCS Long Description",
                    rules: "required|string",
                },
                {
                    name: "dressingCategories",
                    label: "Category",
                    placeholder: "Select category (categories)",
                    rules: "required",
                },
                {
                    name: "dressingTypes",
                    label: "Type",
                    placeholder: "Select type (types)",
                    rules: "required",
                },
                {
                    name: "border",
                    type: "bool",
                },
                {
                    name: "frequenciesOfCare",
                    label: "Frequency Of Care",
                    placeholder: "Select frequency of care(s)",
                    rules: "required",
                },
                {
                    name: "medicareQty28Days",
                    label: "Medicare Allowable Qty per 28 day period",
                    placeholder: "Medicare Allowable Qty per 28 day period",
                    type: "number",
                },
                {
                    name: "qty28DaysIsDressingChange",
                    type: "bool",
                },
                {
                    name: "maximumAdditionalQty28Days",
                    label: "Can supply additional quantities, pending additional validations",
                    placeholder: "Maximum Additional Qty Per 28 Days",
                    type: "number",
                },
                {
                    name: "additionalQtyPerPatient",
                    label: "Medicare Allowable QTY per Patient",
                    placeholder: "Enter quantity",
                    type: "number",
                },
                {
                    name: "exudateTypes",
                    label: "Drainage",
                    placeholder: "Select drainage(s)",
                },
                {
                    name: "thicknessTypes",
                    label: "Thickness Type",
                    placeholder: "Thickness Type(s)",
                },
                {
                    name: "pressureStages",
                    label: "Pressure Stage",
                    placeholder: "Pressure Stage(s)",
                },
                {
                    name: "applicationTypes",
                    label: "Application Type",
                    placeholder: "Application Type(s)",
                },
            ],
        };
    }
}
